import { Button } from 'primereact/button'
import { Dropdown } from 'primereact/dropdown'

interface DropdownSelectorProps {
  label: string
  icon: string
  value: string
  options: Array<{ label: string; value: string }>
  placeholder?: string
  onChange: (value: string, displayValue: string) => void
  onAdd: () => void
}

export const DropdownSelector: React.FC<DropdownSelectorProps> = ({
  label,
  icon,
  value,
  options,
  placeholder = 'Selecione uma opção',
  onChange,
  onAdd,
}) => {
  const handleChange = (selectedValue: string) => {
    const selectedOption = options.find((opt) => opt.value === selectedValue)
    onChange(selectedValue, selectedOption?.label || selectedValue)
  }

  return (
    <div className='alarms-field'>
      <label htmlFor={label} className='alarms-label'>
        <i className={icon} />
        {label}
      </label>
      <div
        style={{
          display: 'flex',
          gap: '0.5rem',
          alignItems: 'center',
        }}
      >
        <Dropdown
          id={label}
          value={value}
          options={options}
          onChange={(e) => handleChange(e.value)}
          optionLabel='label'
          placeholder={placeholder}
          className='alarms-dropdown'
          style={{ flex: 1 }}
        />
        <Button
          icon='pi pi-plus'
          label='Adicionar'
          onClick={onAdd}
          disabled={!value}
        />
      </div>
    </div>
  )
}
